import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../core/redux/action";
import { SuccessToaster } from "../../components/toaster/Toaster";
import { Spinner } from "react-bootstrap";
import InputField from "../../components/Input";
import dayjs from 'dayjs';
import Select from "react-select";
import StoreServices from "../../../services/Store";
import AuthServices from "../../../services/Auth";
import UserServices from "../../../services/User";

const Signin = () => {

  const route = all_routes;
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors }, control } = useForm();
  const [loading, setLoading] = useState(false);
  const [inputError, setInputError] = useState(false);

  // *For Password Visibility Toggle
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  // *For Stores
  const [stores, setStores] = useState([]);

  // *For Get Stores
  const getStores = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await StoreServices.getStores(params)
      setStores(data)
    } catch (error) {
      console.log('getStores => error:', error)
    }
  }

  // *For Login
  const login = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        store_id: formData?.store?.value,
        login: formData?.username,
        password: formData?.password,
      }
      const { data } = await AuthServices.login(obj)
      localStorage.setItem("token", JSON.stringify(data[0]?.access_token))
      const result = await UserServices.getUserProfile()
      let userData = {
        token: data[0]?.access_token,
        store: data[0]?.store,
        permissions: data[0]?.permissions,
        ...result?.data[0]
      }
      dispatch(setUserData(userData))
      SuccessToaster("Login Success")
    } catch (error) {
      setInputError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, []);

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-content">
            <form style={{ width: '70%' }} onSubmit={handleSubmit(login)}>
              <div className="login-userset">
                {/* <div className="d-flex mb-4 align-items-center justify-content-evenly">
                  <ImageWithBasePath
                    src="assets/img/mattress-plus-logo.png"
                    alt="Mattress Plus"
                    className="mb-0"
                    style={{ width: '200px', height: 'auto' }}
                  />
                  <ImageWithBasePath
                    src="assets/img/furniture-plus-logo.png"
                    alt="Furniture Plus"
                    className="mb-0"
                    style={{ width: '200px', height: 'auto' }}
                  />
                </div> */}
                <div className="login-userheading">
                  <h3>Sign In</h3>
                </div>
                <div className="form-login">
                  <label className="form-label">Store</label>
                  <Controller
                    name="store"
                    control={control}
                    rules={{ required: 'Please select store.' }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Select
                          className={error ? 'is-invalid' : ''}
                          classNamePrefix="react-select"
                          options={stores.map((e) => { return { label: e?.name, value: e?.id } })}
                          placeholder="Choose Store/Branch"
                          {...field}
                        />
                        {error && <div className="invalid-feedback">{error.message}</div>}
                      </>
                    )}
                  />
                </div>
                <div className="form-login">
                  <InputField
                    label="Username"
                    type="text"
                    icon={
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                    }
                    error={errors?.username?.message || inputError}
                    register={register("username", {
                      required: 'Please enter your username.',
                    })}
                  />
                </div>
                <div className="form-login">
                  <InputField
                    label="Password"
                    type={isPasswordVisible ? "text" : "password"}
                    icon={
                      <span
                        className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                          }`}
                        onClick={togglePasswordVisibility}
                      ></span>
                    }
                    error={errors?.password?.message ? errors?.password?.message : inputError && 'You have entered an invalid username or password.'}
                    register={register("password", {
                      required: 'Please enter the password.',
                    })}
                  />
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label>
                      </div>
                      {/* <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="form-login">
                  <button
                    className="btn btn-login"
                    type="submit"
                    disabled={loading}
                  >
                    {loading &&
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    }
                    Sign In
                  </button>
                </div>
                <div className="form-sociallink">
                  <div className="mt-4 mb-3 d-flex justify-content-center align-items-center copyright-text">
                    <p>Copyright © {dayjs().format('YYYY')} Awish. All rights reserved</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="login-img">
            <ImageWithBasePath
              src="assets/img/login-bg.jpg"
              alt="img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
